<template>
    <div>
        <div v-if="lastPage != 1">
            <nav>
                <ul class="shop-pagination">
                    <!-- Previous page -->
                    <li v-if="currentPage > 1" class="shop-pagination-item prev">
                        <a
                            @click.prevent="fetchPage(primitiveLinks[parseInt(currentPage) - 1].url)"
                            :href="linkPrevHref"
                            :title="__('frontend_js.pagination.previous-unsigned')"
                            class="page-number page-number-prev no-underline"
                            rel="prev"
                        >
                            <span class="prev-next-text">{{ __('frontend_js.pagination.previous-unsigned') }}</span>
                        </a>
                    </li>

                    <!-- Pages with number -->
                    <template v-for="(link, index) in finalLinks">
                        <li :key="index" class="shop-pagination-item" :class="{ disabled: link.disabled, active: link.active }">
                            <span v-if="parseInt(currentPage) == link.label || link.disabled">{{ link.label }}</span>
                            <a v-else @click.prevent="fetchPage(link.url)" :href="link.url" class="page-number">
                                {{ link.label }}
                            </a>
                        </li>
                    </template>

                    <!-- Next page -->
                    <li v-if="currentPage < lastPage" class="shop-pagination-item next">
                        <a
                            @click.prevent="fetchPage(primitiveLinks[parseInt(currentPage) + 1].url)"
                            :href="linkNextHref"
                            :title="__('frontend_js.pagination.next-unsigned')"
                            class="page-number page-number-next no-underline"
                            rel="next"
                        >
                            <span class="prev-next-text">{{ __('frontend_js.pagination.next-unsigned') }}</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>

        <div v-if="showThatsNotAllBtn">
            <div class="content-inner">
                <div class="subcategories-bottom-button subcategories-filter-reset">
                    <h2>{{ __('frontend_js.category.that-is-not-all') }}</h2>
                    <p>{{ __('frontend_js.category.see-them-all') }} {{ categoryTitle }} ({{ coloredProducts.length }})</p>
                    <button class="text-uppercase shop-button spinnerButton" @click="cancelFilters">
                        <span>{{ categoryTitle }} ({{ coloredProducts.length }})</span>
                    </button>
                </div>
            </div>
        </div>

        <div v-if="paginationLocation == 'bottom' && byModel == 'trademark'">
            <div class="content-inner">
                <trademark-thats-not-all-btn />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductFilterService from './../../classes/ProductFilterService';

export default {
    props: {
        paginationData: {},
        byModel: { required: true },
        byModelId: { required: true },
        paginationLocation: { type: String, default: 'top' },
        categoryTitle: { type: String },
    },

    data() {
        return {
            linkPrevHref: '',
            linkNextHref: '',
            lastPage: this.paginationData.last_page,
            primitiveLinks: this.paginationData.links,
        };
    },
    computed: {
        ...mapGetters('product-filters', ['orderString', 'queryFilters', 'filters', 'coloredProducts']),
        ...mapGetters('product-list', ['currentPage']),
        ...mapGetters('auth', ['check']),
        showThatsNotAllBtn() {
            if (this.paginationLocation != 'bottom') return false;
            if (this.byModel != 'category') return false;
            if (this.queryFilters == '') return false;
            if (this.currentPage != this.lastPage) return false;
            const productFilterService = new ProductFilterService();
            const filteredColoredProducts = productFilterService.getFilteredColoredProducts(
                this.filters,
                this.coloredProducts
                // this.categoryTree prezistit naco to je
            );

            if (filteredColoredProducts.length == this.coloredProducts.length) return false;

            return true;
        },
        generateLinks(currentPage, lastPage) {
            const links = [];
            let startMergeRequired = false;
            let endMergeRequired = false;

            if (lastPage > 9) {
                if (currentPage - 5 >= 1) startMergeRequired = true;
                if (currentPage + 5 <= lastPage) endMergeRequired = true;
            }

            for (let page = 1; page <= lastPage; page++) {
                let disabled = false;

                if (!startMergeRequired && endMergeRequired) {
                    if (page > 7 && page < lastPage) {
                        disabled = true;
                        page = lastPage - 1;
                    }
                }

                if (startMergeRequired && !endMergeRequired) {
                    if (page > 1 && page < lastPage - 7) {
                        disabled = true;
                        page = lastPage - 7;
                    }
                }

                if (startMergeRequired && endMergeRequired) {
                    if (page > 1 && page < currentPage - 2) {
                        disabled = true;
                        page = currentPage - 3;
                    }

                    if (page > currentPage + 2 && page < lastPage) {
                        disabled = true;
                        page = lastPage - 1;
                    }
                }

                links.push({
                    href: this.getURL(page),
                    page,
                    disabled,
                    active: page == currentPage,
                    label: disabled ? '...' : page,
                });
            }

            return links;
        },
        finalLinks() {
            const links = [];
            let startMergeRequired = false;
            let endMergeRequired = false;
            let currentPage = parseInt(this.currentPage);
            let lastPage = this.lastPage;
            if (this.lastPage > 9) {
                if (currentPage - 5 >= 1) startMergeRequired = true;
                if (currentPage + 5 <= lastPage) endMergeRequired = true;
            }
            let predneTriBodky = false;
            let zadneTriBodky = false;
            this.primitiveLinks.forEach(link => {
                if (Number.isInteger(parseInt(link.label)) && link.label != '...') {
                    let disabled = false;

                    let page = parseInt(link.label);
                    if (!startMergeRequired && endMergeRequired) {
                        if (page > 7 && page < lastPage) {
                            disabled = true;
                            page = lastPage - 1;
                        }
                        if (zadneTriBodky == true && disabled == true) {
                            return;
                        }
                    }

                    if (startMergeRequired && !endMergeRequired) {
                        if (page > 1 && page < lastPage - 6) {
                            disabled = true;
                            page = lastPage - 7;
                        }
                        if (predneTriBodky == true && disabled == true) {
                            return;
                        }
                    }

                    if (startMergeRequired && endMergeRequired) {
                        if (page < currentPage) {
                            if (page > 1 && page < currentPage - 2) {
                                disabled = true;
                                page = currentPage - 3;
                            }
                            if (predneTriBodky && disabled == true) {
                                return;
                            }
                        }
                        if (page > currentPage) {
                            if (page > currentPage + 2 && page < lastPage) {
                                disabled = true;
                                page = lastPage - 1;
                            }
                            if (zadneTriBodky && disabled == true) {
                                return;
                            }
                        }
                    }

                    links.push({
                        url: link.url,
                        active: parseInt(link.label) == currentPage,
                        label: disabled ? '...' : page,
                        disabled: disabled,
                    });
                    if (disabled && startMergeRequired) {
                        predneTriBodky = true;
                    }
                    if (disabled && endMergeRequired && page > currentPage) {
                        zadneTriBodky = true;
                    }
                }
            });

            return links;
        },
    },

    created() {
        this.$store.commit('product-list/SET_CURRENT_PAGE', this.paginationData.current_page);
        this.setupLinks();
        this.$root.$on('itemsLoaded', this.itemsLoaded);
    },

    methods: {
        async fetchPage(page) {
            $('html, body').animate({ scrollTop: $('#filterWrapperForScrolling').offset().top }, 'slow');

            this.$store.commit('product-list/SET_LOADING', true);
            // const response = await this.$store.dispatch('product-list/fetchColoredProducts', { url: this.baseUrl, page: page });
            const response = await this.$store.dispatch('product-list/fetchColoredProductsNew', { url: page });
            this.$root.$emit('paginated-products-fetched', response);
            this.primitiveLinks = response.data.colored_products.links;
            this.$store.commit('product-list/SET_CURRENT_PAGE', page.split('page=').pop());

            //Toto nastavuje url parameter pri kliknuti na paginate cislo aby sme si to pamatali do buducna
            if (this.byModel == this.$config.product_list_by_search) {
                const urlParams = new URLSearchParams(window.location.search);
                window.history.pushState(null, null, this.orderString + '?q=' + urlParams.get('q') + `&page=${this.currentPage}`);
            } else {
                window.history.pushState(null, null, '?' + this.orderString + `page=${this.currentPage}`);
            }
            this.$store.commit('product-list/SET_LOADING', false);
        },
        itemsLoaded(paginationData) {
            this.$store.commit('product-list/SET_CURRENT_PAGE', paginationData.data.colored_products.current_page);
            this.lastPage = paginationData.data.colored_products.last_page;
            this.primitiveLinks = paginationData.data.colored_products.links;
            this.setupLinks();
        },
        setupLinks() {
            let currentPageNumberFromPrimitiveLinks = parseInt(
                this.primitiveLinks.filter(link => parseInt(link.label) == this.currentPage)[0].label
            );
            this.linkPrevHref = this.getURL(currentPageNumberFromPrimitiveLinks - 1);
            this.linkNextHref = this.getURL(currentPageNumberFromPrimitiveLinks + 1);
        },
        getURL(pageNumber) {
            // It's better to use vue-router for this kind of stuff
            const urlParser = new URL(window.location);
            urlParser.searchParams.set('page', pageNumber);

            return urlParser.href;
        },
        cancelFilters() {
            const filters = {};
            $('html, body').animate({ scrollTop: $('#filterWrapperForScrolling').offset().top }, 'slow');
            for (const key in this.filters) {
                this.$store.commit('product-filters/SET_FILTER', {
                    key: key,
                    value: [],
                });
            }

            this.$root.$emit('filterChanged');
        },
    },
};
</script>

<style lang="scss" scoped>
.page-number {
    cursor: pointer;
}

.shop-pagination .prev-next-text {
    display: none;
}

.vermont .subcategories-top-pagination .shop-pagination .prev-next-text {
    display: inline;
    width: auto !important;
}

.vermont .subcategories-top-pagination .shop-pagination .next,
.vermont .subcategories-top-pagination .shop-pagination .prev {
    width: auto !important;
    max-width: none !important;
}

.vermont .subcategories-top-pagination .shop-pagination .next .prev-next-text {
    padding-right: 10px;
    margin-left: 10px;
}

.vermont .subcategories-top-pagination .shop-pagination .prev .prev-next-text {
    padding-left: 10px;
    margin-right: 10px;
}
</style>
